import React from 'react';

const NoInvoicesOldCustomer = (props) => {

  return (
    <>
      {/* <div className='mainTitle'>{props.mainTitle}</div> */}
      <div className="no-invoices-container">
        <div className="new-customer-text">אופס...</div>
        <div className="new-invoices-date">לא מצאנו חשבונית להצגה</div>
      </div>
   </>
  );
};
export default NoInvoicesOldCustomer;
